import React from 'react';
import { SvgIcon } from '@mui/material';

const FeedbackIcon = props => {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 44 40" version="1.1">
        <g
          id="FeedbackIcon"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Dashboard-Scrolled-Partially-Populated-Copy-2"
            transform="translate(-685.000000, -3666.000000)"
          >
            <g
              id="Group-2-Copy-4"
              transform="translate(-2.000000, 3636.000000)"
            >
              <rect
                id="Rectangle-Copy-12"
                x="0"
                y="49"
                width="1441"
                height="514"
              ></rect>
              <circle id="Oval-Copy-2" cx="708" cy="49" r="46.5"></circle>
              <g
                id="feedback-copy"
                transform="translate(687.000000, 30.000000)"
                fill="currentColor"
                fillRule="nonzero"
              >
                <path
                  d="M10.9166917,10 L31.0833083,10 C31.5899938,10 32,9.55273273 32,9 C32,8.44726727 31.5899938,8 31.0833083,8 L10.9166917,8 C10.4100062,8 10,8.44726727 10,9 C10,9.55282647 10.4100921,10 10.9166917,10 Z"
                  id="Path1"
                ></path>
                <path
                  d="M21.1428342,20 L10.8571658,20 C10.3833822,20 10,20.4472673 10,21 C10,21.5527327 10.3833822,22 10.8571658,22 L21.1428342,22 C21.6166178,22 22,21.5527327 22,21 C22,20.4472673 21.6166178,20 21.1428342,20 Z"
                  id="Path2"
                ></path>
                <path
                  d="M40.4909141,3.63638688 C40.4378047,3.63638688 40.3863281,3.64959709 40.3333906,3.65206868 L40.3333906,3.63638688 C40.3333906,1.63090677 38.6880313,0 36.6666953,0 L3.66669531,0 C1.64535938,0 0,1.63090677 0,3.63638688 L0,39.090882 C0,39.4584667 0.22378125,39.7904264 0.565726563,39.9307103 C0.6785625,39.9777557 0.798445313,40 0.916609375,40 C1.15474219,40 1.38926563,39.907699 1.56475,39.7336652 L10.4628906,30.9090754 L36.6666953,30.9090754 C38.6880313,30.9090754 40.3333906,29.2782539 40.3333906,27.2726885 L40.3333906,12.1941304 L42.9723594,9.57740117 C42.9723594,9.57740117 42.9723594,9.57740117 42.9723594,9.5765489 C43.6258281,8.92848164 44,8.03180677 44,7.11646716 C44,5.19715171 42.4263125,3.63638688 40.4909141,3.63638688 Z M38.5,27.2726885 C38.5,28.2749598 37.6781797,29.0908394 36.6666953,29.0908394 L10.0833047,29.0908394 C9.83984375,29.0908394 9.60703906,29.1867199 9.43516406,29.3571742 L1.83330469,36.8962828 L1.83330469,3.63638688 C1.83330469,2.63411558 2.655125,1.81823605 3.66660938,1.81823605 L36.6666094,1.81823605 C37.6782656,1.81823605 38.5,2.63411558 38.5,3.63638688 L38.5,4.25735191 C38.3259766,4.3759881 38.1595156,4.50647087 38.0094687,4.65553316 L28.0355625,14.5454623 L10.0833047,14.5454623 C9.57661719,14.5454623 9.16660938,14.952081 9.16660938,15.4545803 C9.16660938,15.9570796 9.57661719,16.3636983 10.0833047,16.3636983 L26.5648281,16.3636983 L25.6845703,20.7307376 C25.6237266,21.0290326 25.7186016,21.3371288 25.93525,21.5519012 C26.1089297,21.7241453 26.3434531,21.8182361 26.5833906,21.8182361 C26.6425156,21.8182361 26.7033594,21.8120145 26.7623984,21.8005088 L31.3439844,20.8913908 C31.5229922,20.8558511 31.6859297,20.7697716 31.8130313,20.6427832 L38.5,14.0121108 L38.5,27.2726885 Z M30.7137187,19.1628137 L27.7524844,19.7505401 L28.3451094,16.8102034 L36.6662656,8.55782875 L39.0370234,10.9089902 L30.7137187,19.1628137 Z M41.6760781,8.29192004 L40.3333047,9.62359428 L37.962375,7.2722624 L39.3055781,5.94016202 C39.6171016,5.63206586 40.0485937,5.45453771 40.4908281,5.45453771 C41.4146562,5.45453771 42.1666094,6.20027528 42.1666094,7.11646716 C42.1666953,7.55325632 41.9876016,7.98211934 41.6760781,8.29192004 Z"
                  id="Shape1"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default FeedbackIcon;
